import React from "react";
import { View, Text } from "react-native";

const CeoS = () => {
  return (
    <View>
      <Text>CeoS</Text>
    </View>
  );
};

export default CeoS;
